export const ORDER_SUMMARY_TEST_ID = {
  order: 'order-summary',
  software: 'software-plan-summary',
  promo: 'promo-summary',
  subHeadline: 'subHeadline',
};
